module.exports = __webpack_public_path__ + "static/media/node-icon.5d5408ad.svg";